<template>
  <d-container fluid class="main-content-container p-4">
    <d-modal v-if="modalVisible" size="lg" @close="onModalClose">
      <d-modal-header>
        <d-modal-title>{{ modalTitle }}</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <p class="text-danger text-center" v-if="hasError">{{ errorMessage }}</p>
        <c-input type="image" container-class="mb-3" placeholder="Sélectionner un logo"
                 default="DEFAULT_OPERATOR_ICON" v-model="logo" :state="logoState">
          Veuillez charger un logo
        </c-input>
        <d-form-row>
          <d-col class="pr-3 border-right">
            <c-input type="color" container-class="mb-3" label="Couleur de l'opérateur" v-model="color">
              Veuillez entrer une couleur
            </c-input>
            <c-input container-class="mb-3" label="Nom de l'opérateur" placeholder="Ex: My-CoolPay" v-model="name"
                     :state="nameState">
              Veuillez saisir un nom
            </c-input>
            <c-input container-class="mb-3" label="Slug" placeholder="Ex: MCP" v-model="slug" :state="slugState">
              Veuillez saisir un slug
            </c-input>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Solde My-CoolPay" placeholder="Ex: 500"
                     :value="balance" disabled>
            </c-input>
            <c-input type="price" currency="%" container-class="mb-3" label="Commissions opérateur - Dépôt"
                     placeholder="Ex: 3" v-model="operator_deposit_rate" :state="operator_deposit_rateState">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Frais opérateur - Dépôt"
                     placeholder="Ex: 500" v-model="operator_deposit_fees" :state="operator_deposit_feesState">
              Veuillez saisir un montant
            </c-input>
            <c-input type="price" currency="%" container-class="mb-3" label="Commissions opérateur - Retrait"
                     placeholder="Ex: 3" v-model="operator_withdrawal_rate" :state="operator_withdrawal_rateState">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Frais opérateur - Retrait"
                     placeholder="Ex: 500" v-model="operator_withdrawal_fees" :state="operator_withdrawal_feesState">
              Veuillez saisir un montant
            </c-input>
            <c-input type="textarea" container-class="mb-3" label="Description" placeholder="Entrez une description..."
                     v-model="description"/>
            <d-form-checkbox v-model="auto_withdraw">
              Retraits automatiques
            </d-form-checkbox>
            <d-form-checkbox v-model="deposit_enabled">
              Autoriser les recharges
            </d-form-checkbox>
            <d-form-checkbox v-model="contribution_enabled">
              Autoriser les contributions
            </d-form-checkbox>
            <d-form-checkbox v-model="payment_enabled">
              Autoriser les paiements
            </d-form-checkbox>
          </d-col>
          <d-col class="ml-2">
            <c-input type="price" currency="%" container-class="mb-3"
                     label="Utilisateurs - Commissions sur les recharges" placeholder="Ex: 3"
                     v-model="user_deposit_rate" :state="user_deposit_rateState">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Utilisateurs - Frais de recharge"
                     placeholder="Ex: 500" v-model="user_deposit_fees" :state="user_deposit_feesState">
              Veuillez saisir un montant
            </c-input>
            <c-input type="price" currency="%" container-class="mb-3"
                     label="Utilisateurs - Commissions sur les retraits" placeholder="Ex: 3"
                     v-model="user_withdrawal_rate" :state="user_withdrawal_rateState">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Utilisateurs - Frais de retrait"
                     placeholder="Ex: 500" v-model="user_withdrawal_fees" :state="user_withdrawal_feesState">
              Veuillez saisir un montant
            </c-input>
            <c-input type="price" currency="%" container-class="mb-3" label="Services - Commissions sur les ventes"
                     placeholder="Ex: 3" v-model="service_payment_rate" :state="service_payment_rateState">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Services - Frais de vente"
                     placeholder="Ex: 500" v-model="service_payment_fees" :state="service_payment_feesState">
              Veuillez saisir un montant
            </c-input>
            <c-input type="price" currency="%" container-class="mb-3" label="Services - Commissions sur les retraits"
                     placeholder="Ex: 3" v-model="service_withdrawal_rate" :state="service_withdrawal_rateState">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Services - Frais de retrait"
                     placeholder="Ex: 500" v-model="service_withdrawal_fees" :state="service_withdrawal_feesState">
              Veuillez saisir un montant
            </c-input>
            <c-input type="price" currency="%" container-class="mb-3"
                     label="Cagnottes - Commissions sur les participations" placeholder="Ex: 3"
                     v-model="raising_deposit_rate" :state="raising_deposit_rateState">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Cagnottes - Frais de participation"
                     placeholder="Ex: 500" v-model="raising_deposit_fees" :state="raising_deposit_feesState">
              Veuillez saisir un montant
            </c-input>
            <c-input type="price" currency="%" container-class="mb-3"
                     label="Cagnottes - Commissions sur les retraits" placeholder="Ex: 3"
                     v-model="raising_withdrawal_rate" :state="raising_withdrawal_rateState">
              Veuillez saisir un nombre entre 0 et 100
            </c-input>
            <c-input type="price" currency="XAF" container-class="mb-3" label="Cagnottes - Frais de retrait"
                     placeholder="Ex: 500" v-model="raising_withdrawal_fees" :state="raising_withdrawal_feesState">
              Veuillez saisir un montant
            </c-input>
          </d-col>
        </d-form-row>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onFormSubmit">
          <template slot="icon">
            <i class="fa fa-save"></i>
          </template>
          Enregistrer
        </c-button-spinner>
        <b-button variant="secondary" @click="onModalClose" class="ml-2">
          <i class="fa fa-times"></i> Fermer
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-modal v-if="settingsModalVisible" size="lg" @close="onSettingsModalClose">
      <d-modal-header>
        <d-modal-title>Paramétrage global des services</d-modal-title>
      </d-modal-header>
      <d-modal-body>
<!--        <p class="text-danger text-center" v-if="hasError">{{ errorMessage }}</p>-->
        <table class="table table-borderless">
          <tbody>
          <tr>
            <td>
              <d-form-checkbox class="mb-4" v-model="payment_enabled">
                <b-image class="table-logo" :src="logo"/>
                {{ name }} {{ payment_enabled ? 'activé' : 'désactivé' }}
              </d-form-checkbox>
            </td>
            <td>
              <c-button-spinner
                class="d-flex" variant="success" :fetching="settingsFetching.payment_enabled"
                @click="onSettingSubmit('payment_enabled')"
              >
                <template slot="icon">
                  <i class="fa fa-save"></i>
                </template>
                Appliquer
              </c-button-spinner>
            </td>
          </tr>
          <tr>
            <td>
              <c-input type="price" currency="%" container-class="mb-3" label="Commissions sur les ventes"
                       placeholder="Ex: 3" v-model="service_payment_rate" :state="service_payment_rateState">
                Veuillez saisir un nombre entre 0 et 100
              </c-input>
            </td>
            <td>
              <c-button-spinner
                class="d-flex" variant="success" :fetching="settingsFetching.service_payment_rate"
                @click="onSettingSubmit('service_payment_rate')"
              >
                <template slot="icon">
                  <i class="fa fa-save"></i>
                </template>
                Appliquer
              </c-button-spinner>
            </td>
          </tr>
          <tr>
            <td>
              <c-input type="price" currency="XAF" container-class="mb-3" label="Frais de vente"
                       placeholder="Ex: 500" v-model="service_payment_fees" :state="service_payment_feesState">
                Veuillez saisir un montant
              </c-input>
            </td>
            <td>
              <c-button-spinner
                class="d-flex" variant="success" :fetching="settingsFetching.service_payment_fees"
                @click="onSettingSubmit('service_payment_fees')"
              >
                <template slot="icon">
                  <i class="fa fa-save"></i>
                </template>
                Appliquer
              </c-button-spinner>
            </td>
          </tr>
          <tr>
            <td>
              <c-input type="price" currency="%" container-class="mb-3" label="Commissions sur les retraits"
                       placeholder="Ex: 3" v-model="service_withdrawal_rate" :state="service_withdrawal_rateState">
                Veuillez saisir un nombre entre 0 et 100
              </c-input>
            </td>
            <td>
              <c-button-spinner
                class="d-flex" variant="success" :fetching="settingsFetching.service_withdrawal_rate"
                @click="onSettingSubmit('service_withdrawal_rate')"
              >
                <template slot="icon">
                  <i class="fa fa-save"></i>
                </template>
                Appliquer
              </c-button-spinner>
            </td>
          </tr>
          <tr>
            <td>
              <c-input type="price" currency="XAF" container-class="mb-3" label="Frais de retrait"
                       placeholder="Ex: 500" v-model="service_withdrawal_fees" :state="service_withdrawal_feesState">
                Veuillez saisir un montant
              </c-input>
            </td>
            <td>
              <c-button-spinner
                class="d-flex" variant="success" :fetching="settingsFetching.service_withdrawal_fees"
                @click="onSettingSubmit('service_withdrawal_fees')"
              >
                <template slot="icon">
                  <i class="fa fa-save"></i>
                </template>
                Appliquer
              </c-button-spinner>
            </td>
          </tr>
          </tbody>
        </table>
      </d-modal-body>
    </d-modal>
    <d-modal v-if="creditModalVisible" @close="onCreditModalClose">
      <d-modal-header>
        <d-modal-title>Créditer/Débiter un opérateur</d-modal-title>
      </d-modal-header>
      <d-modal-body>
        <p class="text-danger text-center" v-if="hasError">{{ errorMessage }}</p>
        <div class="text-center mb-3">
          <b-image :src="logo" thumbnail/>
        </div>
        <c-input container-class="mb-3" label="Nom de l'opérateur" placeholder="Ex: My-CoolPay" v-model="name"
                 :state="nameState" disabled/>
        <c-input type="select" label="Opération" v-model="operation">
          <template slot="first">
            <option value="">Crédit</option>
            <option value="-">Débit</option>
          </template>
        </c-input>
        <c-input type="price" currency="XAF" container-class="mb-3" label="Montant"
                 placeholder="Ex: 500" v-model="amount" :state="amountState">
          Veuillez entrer un montant
        </c-input>
        <c-input type="price" currency="XAF" container-class="mb-3" label="Frais"
                 placeholder="Ex: 10" v-model="fees" :state="feesState">
          Veuillez entrer les frais
        </c-input>
        <c-input container-class="mb-3" label="Auteur de l'opération"
                 placeholder="Ex: Bob MARLEY" v-model="author" :state="authorState">
          Veuillez entrer votre nom
        </c-input>
        <c-input type="textarea" container-class="mb-3" label="Motif de l'opération" placeholder="Entrez un motif..."
                 v-model="reason"/>
      </d-modal-body>
      <d-modal-footer class="justify-content-center">
        <c-button-spinner variant="success" :fetching="fetchingFormSubmit" @click="onCreditSubmit">
          <template slot="icon">
            <i class="fa fa-check"></i>
          </template>
          Valider
        </c-button-spinner>
        <b-button variant="secondary" @click="onCreditModalClose" class="ml-2">
          <i class="fa fa-times"></i> Annuler
        </b-button>
      </d-modal-footer>
    </d-modal>
    <d-card class="card-small">
      <d-card-header class="px-4">
        <d-input-group class="justify-content-center">
          <d-button class="inline-btn" @click="modalVisible = true">
            <i class="fa fa-plus mr-1"></i> Ajouter un opérateur
          </d-button>
        </d-input-group>
      </d-card-header>
      <d-card-body class="pt-0">
        <c-table :fetching="fetchingData" :table-data="data" :fields="fields" :actions="actions" :per-page="10">
          <p class="text-center" slot="empty">Aucun opérateur trouvé.</p>
        </c-table>
      </d-card-body>
    </d-card>
  </d-container>
</template>

<script>
import {Api, asset, formatAmount, Regex, Toast} from "../../helpers/index"

export default {
  title: "Paramètres des opérateurs",
  data() {
    return {
      fetchingData: false,
      data: [],

      //table header
      fields: [
        {key: 'logo', label: 'Logo', sortable: true},
        {key: 'name', label: 'Nom', sortable: true},
        {key: 'slug', label: 'Slug', sortable: true},
        {key: 'balance', label: 'Solde', sortable: true},
        {key: 'user_deposit_rate', label: '% Rech.', sortable: true},
        {key: 'user_deposit_fees_pretty', label: 'Frais Rech.', sortable: true},
        {key: 'user_withdrawal_rate', label: '% Retrait', sortable: true},
        {key: 'user_withdrawal_fees_pretty', label: 'Frais Retr.', sortable: true},
        {key: 'status', label: 'Retr. auto.', sortable: true},
        {key: 'actions', label: 'Actions'},
      ],

      actions: [
        {type: 'white', icon: 'fa fa-cog', title: "Paramètres de l'opérateur", handler: this.onItemSelect},
        {
          type: 'white',
          icon: 'fa fa-sliders-h',
          title: "Configuration des services",
          handler: this.openSettingsModal
        },
        {
          type: 'outline-primary',
          icon: 'fa fa-exchange-alt',
          title: "Créditer/Débiter l'opérateur",
          handler: this.promptCredit
        },
        {type: 'outline-danger', icon: 'fa fa-times', title: "Supprimer l'opérateur", handler: this.onItemRemove},
      ],

      modalVisible: false,

      selectedItem: null,

      color: null,
      logo: null,
      name: '',
      slug: '',
      description: '',
      auto_withdraw: true,
      operator_deposit_rate: '',
      operator_deposit_fees: '',
      operator_withdrawal_rate: '',
      operator_withdrawal_fees: '',
      user_deposit_rate: '',
      user_deposit_fees: '',
      user_withdrawal_rate: '',
      user_withdrawal_fees: '',
      service_payment_rate: '',
      service_payment_fees: '',
      service_withdrawal_rate: '',
      service_withdrawal_fees: '',
      raising_deposit_rate: '',
      raising_deposit_fees: '',
      raising_withdrawal_rate: '',
      raising_withdrawal_fees: '',

      submitted: false,
      fetchingFormSubmit: false,

      creditModalVisible: false,
      operation: '',
      amount: '',
      fees: '',
      author: '',
      reason: '',

      deposit_enabled: false,
      contribution_enabled: false,
      payment_enabled: false,

      settingsModalVisible: false,
      settingsFetching: {
        payment_enabled: false,
        service_payment_rate: false,
        service_payment_fees: false,
        service_withdrawal_rate: false,
        service_withdrawal_fees: false,
      },
    }
  },
  computed: {
    itemSelected() {
      return !!this.selectedItem
    },
    modalTitle() {
      return this.itemSelected ? "Paramétrage d'un opérateur" : "Ajout d'un opérateur"
    },
    balance() {
      return this.itemSelected ? this.selectedItem.balance : 0
    },
    logoState() {
      return true
      // return !this.submitted || this.logo
    },
    nameState() {
      return !this.submitted || this.name.trim().length > 0
    },
    slugState() {
      return !this.submitted || this.slug.trim().length > 0
    },
    operator_deposit_rateState() {
      return !this.submitted || Regex.isValidRate(this.operator_deposit_rate)
    },
    operator_deposit_feesState() {
      return !this.submitted || Regex.isPositiveNumber(this.operator_deposit_fees)
    },
    operator_withdrawal_rateState() {
      return !this.submitted || Regex.isValidRate(this.operator_withdrawal_rate)
    },
    operator_withdrawal_feesState() {
      return !this.submitted || Regex.isPositiveNumber(this.operator_withdrawal_fees)
    },
    user_deposit_rateState() {
      return !this.submitted || Regex.isValidRate(this.user_deposit_rate)
    },
    user_deposit_feesState() {
      return !this.submitted || Regex.isPositiveNumber(this.user_deposit_fees)
    },
    user_withdrawal_rateState() {
      return !this.submitted || Regex.isValidRate(this.user_withdrawal_rate)
    },
    user_withdrawal_feesState() {
      return !this.submitted || Regex.isPositiveNumber(this.user_withdrawal_fees)
    },
    service_payment_rateState() {
      return !this.submitted || Regex.isValidRate(this.service_payment_rate)
    },
    service_payment_feesState() {
      return !this.submitted || Regex.isPositiveNumber(this.service_payment_fees)
    },
    service_withdrawal_rateState() {
      return !this.submitted || Regex.isValidRate(this.service_withdrawal_rate)
    },
    service_withdrawal_feesState() {
      return !this.submitted || Regex.isPositiveNumber(this.service_withdrawal_fees)
    },
    raising_deposit_rateState() {
      return !this.submitted || Regex.isValidRate(this.raising_deposit_rate)
    },
    raising_deposit_feesState() {
      return !this.submitted || Regex.isPositiveNumber(this.raising_deposit_fees)
    },
    raising_withdrawal_rateState() {
      return !this.submitted || Regex.isValidRate(this.raising_withdrawal_rate)
    },
    raising_withdrawal_feesState() {
      return !this.submitted || Regex.isPositiveNumber(this.raising_withdrawal_fees)
    },
    amountState() {
      return !this.submitted || Regex.isPositiveNumber(this.amount)
    },
    feesState() {
      return !this.submitted || Regex.isPositiveNumber(this.fees)
    },
    authorState() {
      return !this.submitted || this.author.length >= 3
    },
  },
  created() {
    this.fetchingData = true
    Api.get('/operator/list')
      .then(res => {
        this.data = res.data.operators.map(this.mapItem)
      })
      .catch(err => this.error = err)
      .then(() => this.fetchingData = false)
  },
  methods: {
    mapItem(item) {
      return {
        ...item,
        logo: asset(item.logo),
        balance: formatAmount(item.balance),
        user_deposit_fees_pretty: formatAmount(item.user_deposit_fees),
        user_withdrawal_fees_pretty: formatAmount(item.user_withdrawal_fees),
        status: item.auto_withdraw ? "Oui" : "Non",
        statusVariant: item.auto_withdraw ? "success" : "danger",
      }
    },
    onItemSelect(item, noModal) {
      this.selectedItem = item
      this.color = item.color
      this.logo = item.logo
      this.name = item.name
      this.slug = item.slug
      this.description = item.description
      this.auto_withdraw = item.auto_withdraw
      this.operator_deposit_rate = item.operator_deposit_rate
      this.operator_withdrawal_rate = item.operator_withdrawal_rate
      this.operator_deposit_fees = item.operator_deposit_fees
      this.operator_withdrawal_fees = item.operator_withdrawal_fees
      this.user_deposit_rate = item.user_deposit_rate
      this.user_deposit_fees = item.user_deposit_fees
      this.user_withdrawal_rate = item.user_withdrawal_rate
      this.user_withdrawal_fees = item.user_withdrawal_fees
      this.service_payment_rate = item.service_payment_rate
      this.service_payment_fees = item.service_payment_fees
      this.service_withdrawal_rate = item.service_withdrawal_rate
      this.service_withdrawal_fees = item.service_withdrawal_fees
      this.raising_deposit_rate = item.raising_deposit_rate
      this.raising_deposit_fees = item.raising_deposit_fees
      this.raising_withdrawal_rate = item.raising_withdrawal_rate
      this.raising_withdrawal_fees = item.raising_withdrawal_fees
      this.deposit_enabled = item.deposit_enabled
      this.contribution_enabled = item.contribution_enabled
      this.payment_enabled = item.payment_enabled
      if (!noModal)
        this.modalVisible = true
    },
    clearFields() {
      this.color = null
      this.logo = null
      this.name = ''
      this.slug = ''
      this.description = ''
      this.auto_withdraw = true
      this.operator_deposit_rate = ''
      this.operator_withdrawal_rate = ''
      this.operator_deposit_fees = ''
      this.operator_withdrawal_fees = ''
      this.user_deposit_rate = ''
      this.user_deposit_fees = ''
      this.user_withdrawal_rate = ''
      this.user_withdrawal_fees = ''
      this.service_payment_rate = ''
      this.service_payment_fees = ''
      this.service_withdrawal_rate = ''
      this.service_withdrawal_fees = ''
      this.raising_deposit_rate = ''
      this.raising_deposit_fees = ''
      this.raising_withdrawal_rate = ''
      this.raising_withdrawal_fees = ''
      this.deposit_enabled = false
      this.contribution_enabled = false
      this.payment_enabled = false
    },
    onModalClose() {
      this.modalVisible = false
      this.submitted = false
      this.error = null
      this.selectedItem = null
      this.clearFields()
    },
    isFormValid() {
      return this.logoState && this.nameState && this.slugState
        && this.user_deposit_rateState && this.user_deposit_feesState
        && this.operator_deposit_rateState && this.operator_withdrawal_rateState
        && this.operator_deposit_feesState && this.operator_withdrawal_feesState
        && this.user_withdrawal_rateState && this.user_withdrawal_feesState
        && this.service_payment_rateState && this.service_payment_feesState
        && this.service_withdrawal_rateState && this.service_withdrawal_feesState
        && this.raising_deposit_rateState && this.raising_deposit_feesState
        && this.raising_withdrawal_rateState && this.raising_withdrawal_feesState
    },
    onFormSubmit() {
      this.submitted = true

      if (!this.isFormValid()) return

      const route = this.itemSelected ? '/operator/update' : '/operator/create'
      const extraData = this.itemSelected ? {operator_id: this.selectedItem.id} : {}

      this.fetchingFormSubmit = true
      Api.postFormData(route, {
        color: this.color,
        logo: this.logo,
        name: this.name,
        slug: this.slug,
        description: this.description,
        auto_withdraw: this.auto_withdraw ? 1 : 0,
        operator_deposit_rate: this.operator_deposit_rate,
        operator_withdrawal_rate: this.operator_withdrawal_rate,
        operator_deposit_fees: this.operator_deposit_fees,
        operator_withdrawal_fees: this.operator_withdrawal_fees,
        user_deposit_rate: this.user_deposit_rate,
        user_deposit_fees: this.user_deposit_fees,
        user_withdrawal_rate: this.user_withdrawal_rate,
        user_withdrawal_fees: this.user_withdrawal_fees,
        service_payment_rate: this.service_payment_rate,
        service_payment_fees: this.service_payment_fees,
        service_withdrawal_rate: this.service_withdrawal_rate,
        service_withdrawal_fees: this.service_withdrawal_fees,
        raising_deposit_rate: this.raising_deposit_rate,
        raising_deposit_fees: this.raising_deposit_fees,
        raising_withdrawal_rate: this.raising_withdrawal_rate,
        raising_withdrawal_fees: this.raising_withdrawal_fees,
        deposit_enabled: this.deposit_enabled,
        contribution_enabled: this.contribution_enabled,
        payment_enabled: this.payment_enabled,
        ...extraData
      })
        .then(res => {
          const operator = this.mapItem(res.data.operator)
          const operation = this.itemSelected ? "mis à jour" : "créé"

          if (this.itemSelected)
            this.data = this.data.replaceOne(item => item.id === this.selectedItem.id, operator)
          else
            this.data.push(operator)

          this.onModalClose()

          Toast.success(`L'opérateur "${operator.name}" a été ${operation} avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    onItemRemove(item) {
      const ans = prompt(`Veuillez saisir SUPPRIMER pour supprimer l'opérateur "${item.name}".`)
      if (ans !== 'SUPPRIMER') return

      Toast.loading("Suppression de l'opérateur...")
      Api.postFormData('/operator/delete', {
        operator_id: item.id
      })
        .then(res => {
          this.data = this.data.filter(_item => _item.id !== item.id)
          Toast.success(`L'opérateur "${item.name}" a été supprimé avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => Toast.loadingToast.goAway())
    },
    promptCredit(operator) {
      this.onItemSelect(operator, true)
      this.creditModalVisible = true
    },
    onCreditModalClose() {
      this.onModalClose()
      this.creditModalVisible = false
      this.operation = ''
      this.amount = ''
      this.fees = ''
      this.author = ''
      this.reason = ''
    },
    isCreditFormValid() {
      return Regex.isPositiveNumber(this.amount) && Regex.isPositiveNumber(this.fees) && this.author.length >= 3
    },
    onCreditSubmit() {
      this.submitted = true

      if (!this.isCreditFormValid()) return

      this.fetchingFormSubmit = true
      Api.postFormData('/operator/credit', {
        operator_id: this.selectedItem.id,
        amount: this.operation + this.amount,
        fees: this.fees,
        name: this.author,
        message: this.reason
      })
        .then(res => {
          const operator = res.data.operator
          const operation = this.operation ? "débité" : "crédité"

          this.data = this.data.filter(item => item.id !== this.selectedItem.id)

          this.data.push(this.mapItem(operator))
          this.onCreditModalClose()

          Toast.success(`L'opérateur "${operator.name}" a été ${operation} avec succès !`)
        })
        .catch(err => this.error = err)
        .then(() => this.fetchingFormSubmit = false)
    },
    openSettingsModal(operator) {
      this.onItemSelect(operator, true)
      this.settingsModalVisible = true
    },
    onSettingsModalClose() {
      this.onModalClose()
      this.settingsModalVisible = false
    },
    onSettingSubmit(setting_name) {
      this.submitted = true

      if (!this.isFormValid()) return

      this.settingsFetching[setting_name] = true
      Api.postFormData('/operator/set', {
        operator_id: this.selectedItem.id,
        setting: setting_name,
        value: this[setting_name],
      })
        .then(() => Toast.success(`Configuration effectuée avec succès !`))
        .catch(err => this.error = err)
        .then(() => this.settingsFetching[setting_name] = false)
    },
  }
}
</script>

<style scoped>
.table td {
  white-space: normal !important;
  padding: 0 1rem !important;
}
</style>
